"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_system_1 = require("styled-system");

var styled_components_1 = __importDefault(require("styled-components"));

exports.Text = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  margin: 0;\n  padding: 0;\n  ", ";\n"], ["\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  margin: 0;\n  padding: 0;\n  ", ";\n"])), styled_system_1.fontWeight, styled_system_1.fontStyle, styled_system_1.fontSize, styled_system_1.textAlign, styled_system_1.lineHeight, styled_system_1.color, styled_system_1.space);
var templateObject_1;